import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 2em 0;
  background-color: transparent;
  background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);
  z-index: 2;
  ${isMobile} {
    padding: 4em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px;
`;

export const ElImgBoxImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const ElContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  align-items: center;
  position: relative;
  z-index: 2;
  /* justify-content: center; */
  ${isMobile} {
    align-items: center;
    justify-content: center;
    flex-direction: column;
    * {
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }
`;

export const ElHeadLine = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-size: 40px;
  font-weight: 600;
  max-width: 400px;
  color: var(--theme-main-flat-dark-color);
  transition: all 0.4s ease;
  text-transform: none;
  letter-spacing: normal;
`;

export const ElDetails = styled.p`
  /* width: 100%; */
  font-family: Inter;
  text-align: left;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  color: var(--theme-main-flat-dark-color);
  * {
    font-family: Inter;
    text-align: left;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
  ${isMobile} {
    font-size: 16px !important;
    * {
      font-size: 16px !important;
    }
  }
  strong {
    font-weight: 700;
  }
  ul,
  ol {
    list-style: inherit;
    padding-left: revert;
  }
  a {
    color: #000;

    /* Body text */
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    &:hover {
      opacity: 0.6;
    }
  }
`;

export const elCarousol = css`
  width: 100%;
  position: relative;
`;

export const elCarousolBox = css``;

export const elGapBanner = css`
  gap: 20px;
`;

export const elGapTitle = css`
  gap: 10px;
`;

export const ElBannerImageCircle = styled.img`
  max-width: 50%;
  height: auto;
  position: absolute;
  min-height: 10px;
  width: 500px !important;
  rotate: 0deg !important;
  bottom: -30%;
  left: -9%;
  top: auto;
  opacity: 0.6;
`;

export const ElBannerImageInfinite = styled.img`
  max-width: 50%;
  height: auto;
  position: absolute;
  width: 500px !important;
  right: 0;
  top: 39%;
  opacity: 0.6;
`;
